import { api } from "../../axios";

export const actions = {
    // Settings
    GetInflationRate(){
        return api.get("Settings/Inflation");
    },
    ClearUserCashe(context, data){
        return api.post(`Settings/ClearLocalStorage/${data}`);
    },
}